import { gql } from '@apollo/client';

export const GET_PLATFORM_STATS = gql`
  query PlatformStats {
    platformStats {
      totalItems
      totalUsers
      totalCollections
    }
  }
`;

export const GET_PLATFORM_ENTITY_STATS = gql`
  query PlatformEntityStats(
    $entity: StatsEntity!
    $from: DateTime!
    $to: DateTime!
    $granularity: StatsGranularity!
  ) {
    platformEntityStats(entity: $entity, from: $from, to: $to, granularity: $granularity) {
      bucket
      count
    }
  }
`;
